import React from 'react';
import { connect } from 'react-redux';

import styles from './index.module.scss';
import { setFormData as setClaimFormData } from '../../WarrantyClaimForm/redux/action';
import { setFormData as setStandardFormData } from '../../WarrantyStandardForm/redux/actions';
import { setFormData as setTransferFormData } from '../../WarrantyTransferForm/redux/actions';

const mapStateToProps = state => ({
  formData: state.formData,
});

const RadioButton = ({
  value,
  htmlAttributes,
  children,
  setStandardFormData,
  setTransferFormData,
  setClaimFormData,
  fieldKey,
  formData,
}) => {
  const { className, key, ...otherHtmlAttributes } = htmlAttributes;

  function handleChange(event) {
    if (formData.formName == 'WarrantyStandard') {
      setStandardFormData({ [fieldKey]: event.target.value });
    } else if (formData.formName == 'WarrantyClaim') {
      setClaimFormData({ [fieldKey]: event.target.value });
    } else {
      setTransferFormData({ [fieldKey]: event.target.value });
    }
  }

  return (
    <div className={className} key={key}>
      <label className={styles.radio}>
        <div className={`${styles.radioContainer} ${otherHtmlAttributes.disabled ? styles.disabled : ''}`}>
          <input
            type="radio"
            name={fieldKey}
            value={value}
            checked={formData[fieldKey] == value}
            onChange={event => handleChange(event)}
            {...otherHtmlAttributes}
          />
          <span className={styles.radioControl} />
          <div className={styles.contentContainer}>{children}</div>
        </div>
      </label>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  setStandardFormData: hash => dispatch(setStandardFormData(hash)),
  setTransferFormData: hash => dispatch(setTransferFormData(hash)),
  setClaimFormData: hash => dispatch(setClaimFormData(hash)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RadioButton);
